import style from "./WebsiteReport.module.scss";
import className from "classnames/bind";
import {numberFormat} from "~/utils";
import WebsiteReportUser from "./WebsiteUser";
const cn = className.bind(style);
function WebsiteReportGroup({item = []}) {

	return (
		<div className={cn('group-wrapper')}>
			<h3 className={cn('group-name', 'text-lg')}>{item?.label} - {numberFormat(item.total)}</h3>
			<WebsiteReportUser items={item.users} totalService={item.service} total={item.total} />
		</div>
	)
}

export default WebsiteReportGroup;